import { render } from "./TerritorioSectorUsuario1Component.vue?vue&type=template&id=b0a36d14"
import script from "./TerritorioSectorUsuario1Component.vue?vue&type=script&lang=js"
export * from "./TerritorioSectorUsuario1Component.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/mac2/Herd/mix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__